var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('h1',[_vm._v("Deeplink test link")]),_c('p',[_c('a',{attrs:{"href":this.androidLink}},[_vm._v("Android Link "),_c('u',[_vm._v("("+_vm._s(this.androidLink)+")")])])]),_c('p',[_c('a',{attrs:{"href":this.iosLink}},[_vm._v("iOS Link "),_c('u',[_vm._v("("+_vm._s(this.iosLink)+")")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }